document.addEventListener('DOMContentLoaded', function() {
    var iconCustomer = document.getElementById('icon-customer');
    var dropdownMenu = document.getElementById('dropdown-menu');

    iconCustomer.addEventListener('click', function() {
        dropdownMenu.classList.toggle('hidden');
    });

    // Закрити випадаюче вікно при кліці поза ним
    document.addEventListener('click', function(event) {
        if (!iconCustomer.contains(event.target) && !dropdownMenu.contains(event.target)) {
            dropdownMenu.classList.add('hidden');
        }
    });
});